import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

import { LoanTeamSelection } from '@sorare/gameplay/src/components/leaderboard/loan/TeamSelection';

import type {
  LoanTeamPageQuery,
  LoanTeamPageQueryVariables,
} from './__generated__/page.graphql.ts';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOAN_TEAM_PAGE_QUERY = gql`
  query LoanTeamPageQuery(
    $googlePlayStoreCountryCode: String
    $isAndroidApp: Boolean = false
    $isIosApp: Boolean = false
  ) {
    currentUser {
      slug
      ...LoanTeamSelection_currentUser
    }
  }
  ${LoanTeamSelection.fragments.currentUser}
` as TypedDocumentNode<LoanTeamPageQuery, LoanTeamPageQueryVariables>;

const LoanTeamPage = () => {
  const { isIosApp, googlePlayStoreCountryCode } = useIsMobileApp();
  const { data } = useQuery<LoanTeamPageQuery, LoanTeamPageQueryVariables>(
    LOAN_TEAM_PAGE_QUERY,
    {
      variables: {
        googlePlayStoreCountryCode,
        isIosApp,
      },
    }
  );
  if (!data?.currentUser) return null;

  return <LoanTeamSelection currentUser={data?.currentUser} />;
};

export default LoanTeamPage;
